module.exports = __webpack_public_path__ + "images/no-map-available.png";